import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=5d6da07e&scoped=true"
import script from "./Extension.vue?vue&type=script&lang=js"
export * from "./Extension.vue?vue&type=script&lang=js"
import style0 from "./Extension.vue?vue&type=style&index=0&id=5d6da07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6da07e",
  null
  
)

export default component.exports